const MIN_REPEAT_LENGTH = 20;

function plain(text: string): string {
  return text.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}

/**
 * The grey word over the card's rule: the step's name, unless it is a whole
 * sentence that the line below already says (older missions use the spoken
 * question as the step title). A short label such as "Identification" is kept.
 */
export function headerWord(stepTitle: string | undefined, lineText: string | undefined): string | undefined {
  if (!stepTitle) return undefined;
  const title = plain(stepTitle);
  if (title.length >= MIN_REPEAT_LENGTH && lineText && plain(lineText).includes(title)) return undefined;
  return stepTitle;
}
